import request from './request';
import URLS from '../configurations/urls';
import Api from './Api';

class TransactionApi{

    static findTransactions(type, channel, params = {}){
        let options =  Object.assign({}, Api.HTTP_OPTIONS);
        options.url += `${URLS.ARBITER_API_TRANSACTIONS_GROUPS}/${type}/channels/${channel}`;
        options.params = params;
        return request.get(options);
    }

    static getTransaction(tranId, tranType){
        let options =  Object.assign({}, Api.HTTP_OPTIONS);
        options.url += `${URLS.ARBITER_API_TRANSACTION_TYPES}/${tranType}/references/${tranId}`;
        options.params = {};
        return request.get(options);
    }

    static getTransactionStores(){
        let options =  Object.assign({}, Api.HTTP_OPTIONS);
        options.url += `${URLS.ARBITER_API_TRANSACTIONS_STORES}`;
        options.params = {};
        return request.get(options);
    }
}

export default TransactionApi;


// WEBPACK FOOTER //
// ./src/api/TransactionsApi.js